import type { LogEntry, LogAction } from "./types";
export function addLog<TInfo>(logentry: LogEntry<TInfo>): LogAction<TInfo> {
  return {
    type: "ADD_LOG",
    logentry,
  };
}
export function addLogInfo<TInfo>(
  type: string,
  info: TInfo,
  time: number
): LogAction<TInfo> {
  if (info != null) {
    const logEntry: LogEntry<TInfo> = {
      type,
      time,
      info,
    };
    return addLog<TInfo>(logEntry);
  }

  return null;
}
